/* MET SOCIETY theme — light interactions (rotating word, cookie bar, reveals) */
(function () {
  var motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
  var reduce = motionPreference.matches || document.documentElement.hasAttribute('data-reduce-motion');
  document.addEventListener('met:motionpreference', function(event){reduce=event.detail.reduced || motionPreference.matches;});
  if (motionPreference.addEventListener) motionPreference.addEventListener('change', function(event){ reduce = event.matches || document.documentElement.hasAttribute('data-reduce-motion'); });
  // PASSWORD PAGE: strip storefront chrome so the opening-soon screen stands alone
  var isPassword = document.body.classList.contains('template-password');
  if (isPassword) {
    ['.nav', '.foot', 'header.nav', 'footer.foot'].forEach(function(sel){
      document.querySelectorAll(sel).forEach(function(el){ el.remove(); });
    });
  }
  // veil
  var veil = document.querySelector('.veil');
  if (veil) { requestAnimationFrame(function(){ requestAnimationFrame(function(){ veil.classList.add('hide'); }); }); setTimeout(function(){ veil.classList.add('hide'); }, 900); }

  // rotating campaign word — each society in its own colour
  var ROLL = [['a','developer.',250],['a','designer.',318],['a','founder.',27],['a','writer.',272],['an','architect.',258],['a','photographer.',237],['an','artist.',300],['a','marketer.',36],['a','musician.',290],['an','engineer.',244],['a','filmmaker.',326],['a','chef.',58],['a','mechanic.',40],['a','financier.',88],['an','accountant.',83],['an','investor.',93],['a','researcher.',194],['a','producer.',322],['an','editor.',277],['an','electrician.',102],['a','craftsman.',49],['a','driver.',235],['a','diver.',214],['a','pilot.',220],['a','scientist.',188],['an','illustrator.',308],['an','animator.',314],['a','stylist.',338],['a','doctor.',150],['a','surgeon.',156],['a','coach.',118],['a','teacher.',126],['a','professor.',133],['a','historian.',284],['a','lawyer.',241],['a','barista.',45],['a','concierge.',72],['a','baker.',64],['a','pioneer.',21],['an','attendant.',228],['a','tailor.',54],['a','creator.',345],['a','nurse.',144],['a','curator.',334],['a','journalist.',266],['a','miner.',239],['a','chemist.',182],['a','strategist.',200],['a','planner.',206],['an','operator.',243]];
  var MONO = {237:1,239:1,241:1,243:1}; var hue = function(h){ return MONO[h] ? 'oklch(0.82 0.015 248)' : 'oklch(0.72 0.13 ' + h + ')'; };
  var roll = document.querySelector('[data-roll]');
  // shuffle-bag: every society shows once before repeats
  function shuffledBag(){ var a=ROLL.map(function(_,k){return k;}); for(var k=a.length-1;k>0;k--){var j=Math.floor(Math.random()*(k+1));var t=a[k];a[k]=a[j];a[j]=t;} return a; }
  var bag = shuffledBag();
  var i = bag.pop();
  function nextIndex(){ if(!bag.length){ bag=shuffledBag(); if(bag.length>1 && bag[bag.length-1]===i){ var t=bag[0]; bag[0]=bag[bag.length-1]; bag[bag.length-1]=t; } } return bag.pop(); }
  // seed the first word from the bag on load (word + colour)
  (function(){ var w0 = roll && roll.querySelector('.roll__word'); if (w0) { w0.innerHTML = '<span class="art" style="color:var(--ivory-dim)">'+ROLL[i][0]+' </span>'+ROLL[i][1]; w0.style.color = hue(ROLL[i][2]); } })();
  if (roll) setInterval(function(){
    if (reduce || document.hidden) return;
    i = nextIndex();
    var w = roll.querySelector('.roll__word'); if (!w) return;
    w.classList.add('swap');
    setTimeout(function(){
      w.innerHTML = '<span class="art" style="color:var(--ivory-dim)">'+ROLL[i][0]+' </span>'+ROLL[i][1];
      w.style.color = hue(ROLL[i][2]);
      void w.offsetWidth; w.classList.remove('swap');
    }, 130);
  }, 500);

  // Societies page search: collection titles plus intentional aliases.
  var societySearch = document.querySelector('[data-society-search]');
  if (societySearch) {
    var societyCards = [].slice.call(document.querySelectorAll('[data-society-card]'));
    var societyEmpty = document.querySelector('[data-society-empty]');
    societySearch.addEventListener('input', function(){
      var query = societySearch.value.trim().toLowerCase();
      var visible = 0;
      societyCards.forEach(function(card){
        var match = !query || (card.getAttribute('data-search') || '').indexOf(query) !== -1;
        card.hidden = !match;
        if (match) visible++;
      });
      if (societyEmpty) societyEmpty.hidden = visible !== 0;
    });
  }

  // reveals
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} }); }, { threshold: 0.12 });
    document.querySelectorAll('[data-reveal]').forEach(function(el){ io.observe(el); });
    // FAILSAFE: never leave content stuck hidden if the observer misfires on mobile
    setTimeout(function(){ document.querySelectorAll('[data-reveal]:not(.in)').forEach(function(el){ if (el.getBoundingClientRect().top < innerHeight*1.1) el.classList.add('in'); }); }, 1400);
    addEventListener('load', function(){ setTimeout(function(){ document.querySelectorAll('[data-reveal]:not(.in)').forEach(function(el){ if (el.getBoundingClientRect().top < innerHeight) el.classList.add('in'); }); }, 600); });
  } else {
    document.querySelectorAll('[data-reveal]').forEach(function(el){ el.classList.add('in'); });
  }

  document.querySelectorAll('[data-product-section]').forEach(function(section) {
    if(section.dataset.physicalInitialized)return;
    var form = section.querySelector('[data-product-form]');
    var fallback = section.querySelector('[data-variant-fallback]');
    var choices = section.querySelector('[data-variant-options]');
    if (!form || !fallback || !choices) return;
    var id = form.querySelector('[data-variant-id]');
    var button = form.querySelector('[data-product-add]');
    var price = section.querySelector('[data-product-price]');
    var status = section.querySelector('[data-product-status]');
    var groups = [].slice.call(form.querySelectorAll('[data-option-position]'));
    var variants;
    try {
      variants = [].slice.call(choices.options).map(function(option) {
        return { id: option.value, options: JSON.parse(option.dataset.options), price: option.dataset.price, available: option.dataset.available === 'true', imageId: option.dataset.imageId };
      });
    } catch (_) { return; }
    if (!id || !button || !price || !status || !variants.length || Number(choices.dataset.variantCount) > variants.length) return;
    function resolve() {
      if (!groups.length) return variants.find(function(v) { return v.id === id.value; });
      var values = groups.map(function(group) { var checked = group.querySelector('[data-physical-option]:checked'); return checked && checked.value; });
      return variants.find(function(v) { return v.options.length === values.length && v.options.every(function(value, index) { return value === values[index]; }); });
    }
    function update(variant, changeUrl) {
      id.value = variant ? variant.id : '';
      id.disabled = !variant || !variant.available || section.dataset.launchReady !== 'true';
      button.disabled = id.disabled;
      var hidePrice = section.dataset.priceApproved !== 'true';
      price.hidden = hidePrice;
      price.textContent = !hidePrice && variant ? variant.price : '';
      button.textContent = !variant ? button.dataset.unavailableLabel : variant.available && !hidePrice ? button.dataset.addLabel + ' — ' + variant.price : button.dataset.soldOutLabel;
      status.textContent = variant ? variant.options.join(' / ') + (hidePrice ? '' : ' · ' + variant.price) + ' · ' + (variant.available ? button.dataset.availableLabel : button.dataset.soldOutLabel) : button.dataset.unavailableLabel;
      if (changeUrl) {
        var url = new URL(window.location.href);
        url.searchParams.delete('option_values');
        if (variant) url.searchParams.set('variant', variant.id); else url.searchParams.delete('variant');
        window.history.replaceState(window.history.state, '', url);
      }
      var gallery = section.querySelector('.pdp__gallery');
      if (gallery) gallery.dispatchEvent(new CustomEvent('met:variant-image', { detail: { imageId: variant && variant.imageId } }));
      form.dispatchEvent(new CustomEvent('met:variant-change', { bubbles: true, detail: { variantId: variant ? variant.id : null, available: !!(variant && variant.available), physicalOptions: variant ? variant.options.slice() : [] } }));
    }
    var selected = variants.find(function(v) { return v.id === id.value; });
    groups.forEach(function(group, index) { group.querySelectorAll('[data-physical-option]').forEach(function(input) { input.checked = !!selected && input.value === selected.options[index]; }); });
    form.querySelector('[data-option-chips]').hidden = false;
    fallback.hidden = true;
    form.addEventListener('change', function(event) { if (event.target.matches('[data-physical-option]')) update(resolve(), true); });
    form.addEventListener('submit', function(event) {
      var variant = resolve();
      if (!variant || !variant.available || id.disabled || id.value !== variant.id) { event.preventDefault(); update(variant, false); }
    });
    section.addEventListener('met:gallery-ready', function() { update(selected, false); }, { once: true });
    update(selected, false);
  });

  document.querySelectorAll('[data-cart-section]').forEach(function(section) {
    if (!window.fetch || !window.DOMParser || !window.AbortController) return;
    var busy = false;
    var uncertain = false;
    function checkoutLabel() {
      var checkout = section.querySelector('[data-cart-checkout]');
      if (checkout) checkout.textContent = checkout.dataset.shortLabel;
    }
    checkoutLabel();
    function message(text, invalid) {
      var error = section.querySelector('[data-cart-error]');
      error.hidden = false;
      error.querySelector('[data-cart-error-text]').textContent = text;
      if (!invalid) {
        uncertain = true;
        section.dataset.ownerTrialUncertain = 'true';
        var checkout = section.querySelector('[data-cart-checkout]');
        if (checkout) checkout.disabled = true;
      }
      error.focus();
    }
    async function change(line, quantity) {
      if (busy || uncertain) return;
      var input = line.querySelector('[data-cart-quantity]');
      if (!Number.isSafeInteger(quantity) || quantity < 0) {
        input.setAttribute('aria-invalid', 'true');
        message(section.dataset.invalidLabel, true);
        return;
      }
      input.removeAttribute('aria-invalid');
      var index = [].indexOf.call(section.querySelectorAll('[data-cart-line]'), line);
      var pendingEdits = [].slice.call(section.querySelectorAll('[data-cart-line]')).filter(function(row) {
        var field = row.querySelector('[data-cart-quantity]');
        return row !== line && field.value !== field.defaultValue;
      }).map(function(row) { return { key: row.dataset.lineKey, value: row.querySelector('[data-cart-quantity]').value }; });
      busy = true;
      section.setAttribute('aria-busy', 'true');
      section.querySelector('[data-cart-error]').hidden = true;
      section.querySelector('[data-cart-status]').textContent = section.dataset.loadingLabel;
      var controls = [].slice.call(section.querySelectorAll('input, button'));
      var states = controls.map(function(control) { return control.disabled; });
      controls.forEach(function(control) { control.disabled = true; });
      section.querySelectorAll('[data-cart-remove]').forEach(function(link) { link.setAttribute('aria-disabled', 'true'); });
      section.dispatchEvent(new CustomEvent('met:cart:start', { bubbles: true, detail: { key: line.dataset.lineKey, quantity: quantity } }));
      var controller = new AbortController();
      var timeout = setTimeout(function() { controller.abort(); }, 20000);
      try {
        var form = line.querySelector('[data-cart-line-form]');
        var response = await fetch(form.action + '.js', {
          method: 'POST', signal: controller.signal, credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: line.dataset.lineKey, quantity: quantity, sections: [section.dataset.sectionId], sections_url: section.dataset.cartUrl })
        });
        var data = await response.json();
        if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : section.dataset.errorLabel);
        var html = data.sections && data.sections[section.dataset.sectionId];
        if (!html) throw new Error(section.dataset.errorLabel);
        var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-section]');
        if (!next || next.dataset.sectionId !== section.dataset.sectionId || !next.querySelector('[data-cart-content]')) throw new Error(section.dataset.errorLabel);
        section.dataset.ownerTrialAuthorized = next.dataset.ownerTrialAuthorized || 'false';
        section.querySelector('[data-cart-content]').innerHTML = next.querySelector('[data-cart-content]').innerHTML;
        checkoutLabel();
        section.querySelector('[data-cart-status]').textContent = section.dataset.updatedLabel;
        var lines = section.querySelectorAll('[data-cart-line]');
        var lostEdit = false;
        pendingEdits.forEach(function(edit) {
          var row = [].slice.call(lines).find(function(row) { return row.dataset.lineKey === edit.key; });
          if (row) row.querySelector('[data-cart-quantity]').value = edit.value;
          else lostEdit = true;
        });
        if (lostEdit) section.querySelector('[data-cart-status]').textContent += ' ' + section.dataset.reviewLabel;
        var focusLine = [].slice.call(lines).find(function(row) { return row.dataset.lineKey === line.dataset.lineKey; }) || lines[Math.min(index, lines.length - 1)];
        (focusLine ? focusLine.querySelector('[data-cart-quantity]') : section.querySelector('[data-cart-heading]')).focus();
        section.dispatchEvent(new CustomEvent('met:cart:success', { bubbles: true, detail: { key: line.dataset.lineKey, quantity: quantity } }));
      } catch (error) {
        controls.forEach(function(control, i) { control.disabled = states[i]; });
        section.querySelectorAll('[data-cart-remove]').forEach(function(link) { link.removeAttribute('aria-disabled'); });
        section.querySelector('[data-cart-status]').textContent = '';
        message((error.message && error.message !== section.dataset.errorLabel ? error.message + ' ' : '') + section.dataset.errorLabel, false);
        section.dispatchEvent(new CustomEvent('met:cart:error', { bubbles: true, detail: { key: line.dataset.lineKey, quantity: quantity } }));
      } finally {
        clearTimeout(timeout);
        busy = false;
        section.removeAttribute('aria-busy');
        window.MetOwnerTrial?.guardCart(section);
      }
    }
    section.addEventListener('submit', function(event) {
      if (event.target.matches('[data-cart-line-form]')) {
        event.preventDefault();
        var input = event.target.querySelector('[data-cart-quantity]');
        change(event.target.closest('[data-cart-line]'), input.value.trim() === '' ? NaN : Number(input.value));
      } else if (busy || uncertain) event.preventDefault();
      else if ([].some.call(section.querySelectorAll('[data-cart-quantity]'), function(input) { return input.value !== input.defaultValue; })) {
        event.preventDefault();
        message(section.dataset.pendingLabel, true);
      }
    });
    section.addEventListener('click', function(event) {
      var remove = event.target.closest('[data-cart-remove]');
      if (remove) { event.preventDefault(); change(remove.closest('[data-cart-line]'), 0); }
    });
    section.addEventListener('invalid', function(event) {
      if (event.target.matches('[data-cart-quantity]')) {
        event.preventDefault();
        event.target.setAttribute('aria-invalid', 'true');
        message(section.dataset.invalidLabel, true);
      }
    }, true);
  });

  /* ---- PDP swipeable gallery (dots + thumbnail sync + drag) ---- */
  var gallery = document.getElementById('pGallery');
  if (gallery && !gallery.closest('[data-digital-ux]')) {
    var slides = [].slice.call(gallery.querySelectorAll('.pdp__slide'));
    var dotsWrap = document.getElementById('pDots');
    var rail = document.getElementById('pRail');
    var thumbs = rail ? [].slice.call(rail.querySelectorAll('.pdp__thumb')) : [];
    var active = -1;
    if (dotsWrap && slides.length > 1) {
      dotsWrap.innerHTML = slides.map(function(_, i){ return '<button class="pdp__dot'+(i===0?' is-active':'')+'" type="button" data-go="'+i+'" aria-label="Image '+(i+1)+'"></button>'; }).join('');
    }
    var dots = dotsWrap ? [].slice.call(dotsWrap.querySelectorAll('.pdp__dot')) : [];
    function setActive(i){ if(i===active) return; active=i; dots.forEach(function(d,k){ d.classList.toggle('is-active',k===i); d.setAttribute('aria-current', k===i ? 'true' : 'false'); }); thumbs.forEach(function(t,k){ t.classList.toggle('is-active',k===i); t.setAttribute('aria-current', k===i ? 'true' : 'false'); }); }
    function goTo(i){ gallery.scrollTo({ left: gallery.clientWidth*i, behavior:reduce ? 'auto' : 'smooth' }); setActive(i); }
    var productSection = gallery.closest('[data-product-section]');
    gallery.addEventListener('met:variant-image', function(event) {
      var imageId = event.detail.imageId || (productSection && productSection.dataset.defaultImageId);
      var index = slides.findIndex(function(slide) { return slide.dataset.imageId === imageId; });
      goTo(index < 0 ? 0 : index);
    });
    if (rail) rail.hidden = false;
    setActive(0);
    if (productSection) productSection.dispatchEvent(new CustomEvent('met:gallery-ready'));
    var raf=null;
    gallery.addEventListener('scroll', function(){ if(raf) return; raf=requestAnimationFrame(function(){ raf=null; var i=Math.round(gallery.scrollLeft/gallery.clientWidth); setActive(Math.max(0,Math.min(slides.length-1,i))); }); }, {passive:true});
    if (dotsWrap) dotsWrap.addEventListener('click', function(e){ var b=e.target.closest('[data-go]'); if(b) goTo(+b.dataset.go); });
    if (rail) rail.addEventListener('click', function(e){ var b=e.target.closest('[data-go]'); if(b) goTo(+b.dataset.go); });
    var down=false,sx=0,ss=0,moved=false;
    gallery.addEventListener('mousedown', function(e){ down=true; moved=false; sx=e.pageX; ss=gallery.scrollLeft; gallery.style.scrollBehavior='auto'; });
    addEventListener('mousemove', function(e){ if(!down) return; var dx=e.pageX-sx; if(Math.abs(dx)>4) moved=true; gallery.scrollLeft=ss-dx; });
    addEventListener('mouseup', function(){ if(!down) return; down=false; gallery.style.scrollBehavior=reduce ? 'auto' : 'smooth'; if(moved){ var i=Math.round(gallery.scrollLeft/gallery.clientWidth); goTo(Math.max(0,Math.min(slides.length-1,i))); } });
    gallery.addEventListener('dragstart', function(e){ e.preventDefault(); });
  }
})();

